export const setQuery = function (state, value) {
  let query = JSON.stringify(value)
  window.sessionStorage.setItem('query', query)
  state.query = value
}
export const setConditions = function (state, value) {
  let conditions = JSON.stringify(value)
  window.sessionStorage.setItem('conditions', conditions)
  state.conditions = value
}
export const setLeftmenu = function (state, value) {
  state.leftmenu = value
}
export const setEventLimitAttrItemAttr = function (state, value) {
  state.eventLimitAttrItemAttr = value
}
export const setEventLimitAttrItem = function (state, value) {
  state.eventLimitAttrItem = value
}

// 存 已经选择的产品名称
export const EXCHANGE_SELECTED = function (state, rows) {
  state.multipleSelectionAll = rows
}

